import React from 'react';

const TableRow = ({ children }) => {
  return (
    <div className='table-row'>
      {children}
    </div>
  )
}

export default TableRow;
